import { useIsFetching } from '@tanstack/react-query'

import { useTabulationQueryKey } from './useTabulationQueryKey'

export const useIsTabulationFetching = () => {
  const queryKey = useTabulationQueryKey()
  const numberOfFetching = useIsFetching({ queryKey })

  return 0 < numberOfFetching
}
